import { Button } from '@mui/material';
import { useControlsOpen, useRouteStoreActions } from '../../../stores/RouteStore';
import { useMap } from 'react-leaflet';


export default function RoadFeatureApiViewButton() {
    const routeStore = useRouteStoreActions();
    const controlsOpen = useControlsOpen();

    const map = useMap();

    const onClick = () => {
        routeStore.setControlsOpen(!controlsOpen);
    }

    const onMouseEnter = () => {
        map.dragging.disable();
        map.scrollWheelZoom.disable();
        map.doubleClickZoom.disable();
    }
    
    const onMouseLeave = () => {
        map.dragging.enable();
        map.doubleClickZoom.enable();
        map.scrollWheelZoom.enable();
    }

    return (
        <>
            <Button
            variant='contained'
            onClick={onClick} 
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            style={{
                zIndex: 99999, 
                justifyContent: 'center'
                }}
            >
                Verktøy
            </Button>
        </>
    )
             
}